import React from "react";
import './JupyterViewer.css';
import './ChatWithCode/ChatWithCode.css';
import './FileManagerSidebar/FileManagerSidebar.css'
import MarkdownViewer from "./MarkdownViewer/MarkdownViewer";
import BlockOutput from "./BlockOutput/BlockOutput";
// import CodeViewer from "./CodeEditor/CodeViewer";
// import CodeEditor from "./CodeEditor/CodeEditer";
import CodeViewerEditor from "./CodeEditor/CodeEditorInviewer";
import ChatWithCode from "./ChatWithCode/ChatWithCode";
// import CodeEditor from "./CodeEditor/CodeEditer";
import FileManagerSidebar from "./FileManagerSidebar/FileManagerSidebar";
const JupyterNotebookComp = (props) => {
    const { rawIpynb1, originalRawIpynb, RunCodeCell, cellExecutionDetails, StopExecution } = props;
    const [rawIpynb, setRawIpynb] = React.useState(rawIpynb1);
    const [selectedCell, setSelectedCell] = React.useState(-1);
    const [cwcIndex, setCwcIndex] = React.useState(-1);
    const [viewChatWithCode, setViewChatWithCode] = React.useState(false);
    const [debugCellOutput, setDebugCellOutput] = React.useState({});
    const initializeChatHistory = (rawIpynb) => {
        if (!rawIpynb || !rawIpynb.cells) {
            return []; // Return empty array if rawIpynb or rawIpynb.cells is not defined
        }
        return rawIpynb.cells.map(cell => {
            if (cell.cell_type === "code") {
                return ({
                    "isLoading": false,
                    "context": cell['source'].join(''),
                    "chat": [{ type: "outgoing", isCode: true, message: cell['source'].join('') }],
                    "debug": [{ type: "outgoing", isCode: true, message: cell['source'].join('') }],
                });
            }
            // Return other types of cells if needed
            return { "isLoading": false, "context": "", "chat": [{ type: "outgoing", isCode: false, message: "" }], "debug": [{ type: "outgoing", isCode: false, message: "" }] };
        }).filter(Boolean); // Remove null values if any
    };
    const [chatHistory, setChatHistory] = React.useState(initializeChatHistory(rawIpynb));
    const modifyJupyterNotebook = React.useCallback((cellIndex, value) => {
        setRawIpynb(prevRawIpynb => {
            const temp_ipynb = { ...prevRawIpynb }; // Shallow copy the rawIpynb object
            if (temp_ipynb.cells && temp_ipynb.cells[cellIndex]) {
                temp_ipynb.cells[cellIndex] = {
                    ...temp_ipynb.cells[cellIndex],
                    source: value.split(/\r?\n/).map((line, index, array) => index === array.length - 1 ? line : line + '\n')
                };
                modifyChatContext(cellIndex, value);
            }
            return temp_ipynb;
        });
        // setRawIpynb1(rawIpynb);
    }, [originalRawIpynb])
    const modifyChatHistory = React.useCallback((cellIndex, cellChatHistory) => {
        setChatHistory(prevChatHistory => {
            const updatedChatHistory = [...prevChatHistory]; // Shallow copy
            if (updatedChatHistory[cellIndex]) {
                updatedChatHistory[cellIndex] = cellChatHistory;
            }
            return updatedChatHistory;
        });
    }, [originalRawIpynb])
    const clearChatHistory = React.useCallback((cellIndex) => {
        modifyChatHistory(cellIndex, {
            "isLoading": false,
            "context": rawIpynb.cells[cellIndex]['source'].join(''),
            "chat": [{ type: "outgoing", isCode: true, "message": rawIpynb.cells[cellIndex]['source'].join('') }],
            "debug": [{ type: "outgoing", isCode: true, "message": rawIpynb.cells[cellIndex]['source'].join('') }],
        });
    }, [originalRawIpynb])
    const modifyChatContext = (cellIndex, newContext) => {
        setChatHistory(prevChatHistory => {
            const updatedChatHistory = [...prevChatHistory]; // Shallow copy
            if (updatedChatHistory[cellIndex]) {
                const lastchat = updatedChatHistory[cellIndex]?.chat?.pop();
                if (lastchat && lastchat.isCode && lastchat.message !== newContext) {
                    if (lastchat.type === "outgoing") {
                        updatedChatHistory[cellIndex].chat.push({ type: "outgoing", isCode: true, message: newContext });
                    } else {
                        updatedChatHistory[cellIndex].chat.push(lastchat);
                        updatedChatHistory[cellIndex].chat.push({ type: "outgoing", isCode: true, message: newContext });
                    }
                } else updatedChatHistory[cellIndex].chat.push(lastchat);

                // update debug
                const lastdebugchat = updatedChatHistory[cellIndex]?.debug?.pop();
                if (lastdebugchat && lastdebugchat.message !== newContext) {
                    if (lastdebugchat.type === "outgoing") {
                        updatedChatHistory[cellIndex].debug.push({ type: "outgoing", isCode: true, message: newContext });
                    } else {
                        updatedChatHistory[cellIndex].debug.push(lastdebugchat);
                        updatedChatHistory[cellIndex].debug.push({ type: "outgoing", isCode: true, message: newContext });
                    }
                } else updatedChatHistory[cellIndex].debug.push(lastdebugchat);
            }
            return updatedChatHistory;
        });
    };
    const SetCwcCellIndex = (cellIndex) => {
        setCwcIndex(cellIndex);
        setSelectedCell(cellIndex);
        setViewChatWithCode(true);
    }
    const onChangeJupyterNotebookCode = React.useCallback((cellIndex, value) => {
        modifyJupyterNotebook(cellIndex, value);
    }, []);
    const selectDiv = (e) => {
        setSelectedCell(e);
    }
    const selectNextCodeCell = React.useCallback((cellIndex) => {
        for (let i = cellIndex + 1; i < originalRawIpynb['cells'].length; i++) {
            if ('cell_type' in originalRawIpynb['cells'][i] && originalRawIpynb['cells'][i]['cell_type'] === "code") {
                selectDiv(i);
                if (selectedCellRef.current && containerRef.current) {
                    handleScrollOnfocus();
                }
                return;
            }
        }
    }, [originalRawIpynb])
    React.useEffect(() => {
        setRawIpynb(rawIpynb1);
        setCwcIndex(-1);
        setSelectedCell(-1);
        setViewChatWithCode(false);
        setChatHistory(initializeChatHistory(originalRawIpynb));

    }, [originalRawIpynb]);
    React.useEffect(() => {
        setRawIpynb(rawIpynb1);
    }, [rawIpynb1]);
    const ChangeCwcView = React.useCallback((value) => { setViewChatWithCode(value); }, []);
    function classNames(...args) {
        return args.filter(Boolean).join(' ')
    }
    const selectedCellRef = React.useRef(null);
    const containerRef = React.useRef(null);

    // React.useEffect(() => {
    //     if (selectedCellRef.current && containerRef.current) {
    //         handleScrollOnfocus();
    //     }
    // }, [selectedCell]);

    const handleScrollOnfocus = async () => {
        await new Promise(resolve => setTimeout(resolve, 200));
        if (selectedCellRef.current && containerRef.current) {
            const containerHeight = containerRef.current.clientHeight;
            const selectedCellOffsetTop = selectedCellRef.current.offsetTop;
            const selectedCellHeight = selectedCellRef.current.clientHeight;
            const scrollPosition = selectedCellOffsetTop - containerHeight + selectedCellHeight - 200;
            if (scrollPosition > containerRef.current.scrollTop) {
                containerRef.current.scrollTo({ top: scrollPosition, behavior: 'smooth' });
            }
        }
    }
    const debugOutputError = React.useCallback((cellIndex, error) => {
        if (cellIndex === -1) {
            setDebugCellOutput({});
        }
        setDebugCellOutput({ cellIndex: cellIndex, error: error });
        setCwcIndex(cellIndex);
        setViewChatWithCode(true);
    }, [])
    const AddCodeCellInNotebook = () => {
        setRawIpynb(prevRawIpynb => {
            const tempRawIpynb = { ...prevRawIpynb }
            tempRawIpynb.cells.push({
                cell_type: "code",
                execution_count: null,
                metadata: {},
                outputs: [],
                source: [],
            })
            return tempRawIpynb;
        });
        setChatHistory(prevChatHistory => {
            const temphistory = [...prevChatHistory];
            temphistory.push({ "isLoading": false, "context": "", "chat": [{ type: "outgoing", isCode: true, message: "" }], "debug": [{ type: "outgoing", isCode: true, message: "" }] })
            return temphistory;
        })
    }
    if (!rawIpynb || !('cells' in rawIpynb)) return <div>Invalid Notebook</div>
    return (
        <div className="jupyter-container" style={viewChatWithCode ? { justifyContent: "flex-start" } : { justifyContent: "flex-start" }}>
            {/* {!viewChatWithCode && */}
            <div className={classNames("custom-scrollbar", "FileManager-side-drawer", viewChatWithCode && "close-drawer-fileManager")}>
                <FileManagerSidebar />
            </div>
            {/* } */}
            <div className="jupyter-viewer custom-scrollbar" ref={containerRef}>
                {rawIpynb['cells'].map((cell, index) => {
                    return (
                        <div
                            key={index}
                            className={classNames('block', selectedCell === index && 'focused-div')}
                            ref={selectedCell === index ? selectedCellRef : null}
                        >
                            {!('cell_type' in cell) ? null :
                                // block source
                                <>{(cell['cell_type'] === 'markdown') ? <MarkdownViewer cell={cell} /> :
                                    <div className="cell-with-toolbar">
                                        <div onClick={() => selectDiv(index)} key={index}>
                                            <CodeViewerEditor
                                                cellExecutionDetails={cellExecutionDetails.length >= index ? cellExecutionDetails[index] : null}
                                                StopExecution={StopExecution}
                                                code={cell['source']}
                                                isOnFocus={selectedCell === index}
                                                onChangeCode={onChangeJupyterNotebookCode}
                                                cellIndex={index}
                                                RunCodeCell={RunCodeCell}
                                                selectNextCodeCell={selectNextCodeCell}
                                            />
                                        </div>
                                        <div className="cell-toolbar">
                                            <button onClick={() => SetCwcCellIndex(index)}>CHAT WITH CODE</button>
                                        </div>
                                    </div>
                                }</>
                            }
                            {!('outputs' in cell) ? null :
                                // block output
                                <div onClick={() => selectDiv(index)} key={index}>
                                    <BlockOutput
                                        cell={cell}
                                        outputs={cell.outputs}
                                        debugOutputError={debugOutputError}
                                        cellIndex={index}
                                    />
                                </div>
                            }
                        </div>
                    )
                })}
                <button onClick={() => { AddCodeCellInNotebook() }}>Add Cell</button>
            </div>

            {cwcIndex >= 0 && rawIpynb['cells'][cwcIndex] && viewChatWithCode &&
                <>
                    {
                        <div className={classNames("cwc-side-drawer", !viewChatWithCode && "close-drawer")}>
                            <ChatWithCode
                                cwcIndex={cwcIndex}
                                cwcCellHistory={chatHistory[cwcIndex]}
                                passChatHistory={chatHistory}
                                modifyJupyterNotebook={modifyJupyterNotebook}
                                ChangeCwcView={ChangeCwcView}
                                clearChatHistory={clearChatHistory}
                                modifyChatHistory={modifyChatHistory}
                                // cellOriginalCode={rawIpynb['cells'][cwcIndex]}
                                debugCellOutput={(debugCellOutput && debugCellOutput.cellIndex === cwcIndex) ? debugCellOutput.error : ""}
                                setDebugCellOutput={setDebugCellOutput}
                            />
                        </div>
                    }
                </>
            }
        </div>

    )
}

export default JupyterNotebookComp;